module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("您尚未提交您的店铺名称")]), _vm._v(" "), _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("确认")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-63c3e113"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/NameRegister.vue
// module id = 542
// module chunks = 1